export default __webpack_public_path__ + "static/media/MetalCastingImg.1be59b4f.jpg";